<template>
  <div :class="priceClass">
    {{
      displayPriceWithTva && priceWithTva
        ? formatPrice(priceWithTva)
        : formatPrice(price)
    }}
    <span class="selected-taxe-label" v-if="billing === 'monthly'">
      {{ displayPriceWithTva && priceWithTva ? 'TTC/mois' : 'HT/mois' }}
    </span>
    <span class="selected-taxe-label" v-if="billing === 'annually'">
      {{ displayPriceWithTva && priceWithTva ? 'TTC/an' : 'HT/an' }}
    </span>
    <span class="selected-taxe-label" v-if="billing === 'life'">
      {{ displayPriceWithTva && priceWithTva ? 'TTC' : 'HT' }}
    </span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  price: number
  priceWithTva?: number
  billing: string
  displayPriceWithTva: boolean
  priceClass?: string
}>()

function formatPrice(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
  }).format(amount)
}
</script>

<style scoped>
.selected-taxe-label {
  font-size: 0.75rem;
  font-weight: 400;
}
</style>
